module.exports = __webpack_public_path__ + "static/media/ne.ce2d055f.svg";